import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';
import Api from 'api';
import {
  SCA_RESUME_REQUEST,
  SCA_RESUME_SUCCESS,
  SCA_RESUME_FAILURE,
  SCA_POLL_LOCAL_RESET,
} from '../constants';
import * as actions from '../actions';
import {
  clearStoredScaActionUrl,
  setStoredScaActionUrl,
  clearResumeFailed,
  markResumeFailed,
} from '../logic/sca';

export function* scaResumeWorker() {
  try {
    const result = yield call(Api.resumeBankSetup);
    const { data } = result || {};

    if (data?.next === 'resume' && data?.sca_bank_action_url) {
      const actionUrl = data.sca_bank_action_url;

      yield call(setStoredScaActionUrl, actionUrl); // dialog fallback
      yield put({ type: SCA_RESUME_SUCCESS }); // stop spinner
      yield put(actions.scaRecipientEnroll({ actionUrl })); // open SCAVerificationDialog

      return; // navigation
    }

    if (data?.next === 'done') {
      yield call(clearStoredScaActionUrl);
      yield call(clearResumeFailed);

      yield put(actions.showSnackbar({
        severity: 'success',
        message: { id: 'sca.toast.resume.done', defaultMessage: 'Bank account connected and ready.' },
      }));

      yield put({ type: SCA_RESUME_SUCCESS });

      // Stop any ongoing poll first (prevent duplicate /api/user calls)
      yield put({ type: SCA_POLL_LOCAL_RESET });

      // Refresh user to get latest bank details (iban/bank_account_added_at)
      if (actions.fetchUserSelfRequest) {
        yield put(actions.fetchUserSelfRequest());
      }

      return;
    }

    if (data?.next === 'start_over') {
      yield call(clearStoredScaActionUrl);
      yield call(clearResumeFailed);

      yield put(actions.showSnackbar({
        severity: 'warning',
        message: { id: 'sca.toast.resume.startOver', defaultMessage: 'Please re-enter your bank details.' },
      }));

      yield put({ type: SCA_RESUME_FAILURE, error: 'start_over' });
      return;
    }

    if (data?.next === 'resume_failed') {
      yield call(markResumeFailed);

      yield put(actions.showSnackbar({
        severity: 'error',
        message: { id: 'sca.toast.resume.failed', defaultMessage: 'Couldn’t resume right now. Try again shortly.' },
      }));

      yield put({ type: SCA_RESUME_FAILURE, error: 'resume_failed' });
      return;
    }

    // Unexpected shape -> generic error toast
    yield put(actions.showSnackbar({
      severity: 'error',
      message: { id: 'sca.toast.resume.server', defaultMessage: 'Something went wrong. Please try again.' },
    }));

    yield put({ type: SCA_RESUME_FAILURE, error: 'unknown' });
  } catch (e) {
    // Map 502/500 to the same generic UX; the UI can show generic retry
    yield put(actions.showSnackbar({
      severity: 'error',
      message: { id: 'sca.toast.resume.server', defaultMessage: 'Something went wrong. Please try again.' },
    }));
    yield put({ type: SCA_RESUME_FAILURE, error: 'server_error' });
  }
}

export function* watchScaResume() {
  yield takeLatest(SCA_RESUME_REQUEST, scaResumeWorker);
}

export default [watchScaResume()];
